import { render, staticRenderFns } from "./PorAssunto.vue?vue&type=template&id=6a0f7d02&lang=pug&"
import script from "./PorAssunto.vue?vue&type=script&lang=js&"
export * from "./PorAssunto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports